module.exports = __webpack_public_path__ + "static/media/CTLA_10-178w.35aea642.jpg";